import React, { useState } from 'react';

const GROUPS = [
  { key: 'input', label: 'Input' },
  { key: 'transform', label: 'Transform' },
  { key: 'output', label: 'Output' }
];

// Node palette as a horizontal bar above the canvas, with tabbed groups.
export default function Palette({ metas = [], onAdd }) {
  const [activeTab, setActiveTab] = useState(GROUPS[0].key);
  const items = (metas || []).filter((meta) => meta.category === activeTab);

  return (
    <div className="flow-palette">
      <div className="flow-palette-tabs">
        {GROUPS.map((group) => (
          <button
            key={group.key}
            type="button"
            className={`flow-palette-tab ${
              activeTab === group.key ? 'flow-palette-tab-active' : ''
            }`}
            onClick={() => setActiveTab(group.key)}
          >
            {group.label}
          </button>
        ))}
      </div>
      <div className="flow-palette-group">
        {items.map((meta) => (
          <button
            key={meta.id}
            type="button"
            className="flow-palette-item"
            title={meta.hint ? `${meta.description} — ${meta.hint}` : meta.description}
            onClick={() => onAdd(meta.id)}
          >
            <span className="flow-palette-item-name">{meta.name}</span>
            <span className="flow-palette-item-desc">{meta.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
